import { takeLatest, put, call, select } from 'redux-saga/effects'
import { FETCH_CUSTOMER, SWAP_LANGUAGE } from './constants'
import { fetchCustomer, fetchOptions } from './actions'
import { fetchCustomerApi, fetchOptionsApi } from './services'
import { getParam } from '../../helpers/parameters'
import STYLES from '../../constants/styles'
import { selectLanguage } from './selectors'

function* fetchCustomerWorker({ custOverride }) {
  const language = yield select(selectLanguage)
  const stylesType = yield call(getParam, 'stylesType')
  const cust = custOverride || new URLSearchParams(window.location.search).get('customer-override')
  if (stylesType === 'dynamic') {
    const response = yield call(fetchCustomerApi, cust)
    const customer = Object.keys(response.styleRoot)[0]
    const options = yield call(fetchOptionsApi, customer, language)
    yield put(fetchOptions.success(options))
    yield put(fetchCustomer.success(customer))
  } else {
    yield put(fetchCustomer.success(STYLES, 'trial'))
  }
}

export default function* defaultSaga() {
  yield takeLatest(
    [FETCH_CUSTOMER.REQUEST, SWAP_LANGUAGE], fetchCustomerWorker
  )
}



// WEBPACK FOOTER //
// ./src/containers/App/sagas.js